import React from 'react';
import DynamicNavigation from "../../../components/layout/navigation/DynamicNavigation"
import PolicyBalance from '../components/history/GetPolicyDisplayMin'

const Payments = () => {
    return (
        <>
            {/* <Header /> */}
            <DynamicNavigation/>
            <div className="min-h-screen bg-base-200 pt-28 pb-8">
                <div className="container mx-auto px-4 max-w-7xl">
                    <PolicyBalance/>
                </div>
            </div>
        </>
    );
};

export default Payments;
